import { Container } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { AiOutlineDownload, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import Particle from "../../Particle";
import pdf from "../../assets/Resume.pdf";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import Zoom from "react-reveal/Zoom";
import React, { useState, useEffect } from "react";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const resumeLink =
  "https://raw.githubusercontent.com/kghthor/Personal-Portfolio/master/src/assets/Harish%20K%20G_Software_Engineer.pdf";

function Resume() {
  const [width, setWidth] = useState(1200);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function goToPrevPage() {
    setPageNumber(prevPage => Math.max(prevPage - 1, 1));
  }

  function goToNextPage() {
    setPageNumber(prevPage => Math.min(prevPage + 1, numPages));
  }

  return (
    <div>
      <section className="home-section">
        <Container fluid id="home">
          <Particle />
          <Container className="home-content">
            <div
              className="d-flex justify-content-center"
              width="100%"
              style={{ backgroundColor: "#fbd9ad" }}
            >
              <Zoom left cascade>
                <h1 style={{ color: "rgb(134 61 176)" }}>RESUME</h1>
              </Zoom>
            </div>
            <div fluid className="certificate-section" id="about">
              <div className="d-flex justify-content-center mt-4">
                <Button 
                  variant="primary" 
                  href={pdf} 
                  download="Harish_K_G_Resume.pdf"
                  className="d-flex align-items-center"
                >
                  <AiOutlineDownload className="me-2" />
                  Download Full Resume
                </Button>
              </div>
              
              <div className="resume d-flex justify-content-center flex-column align-items-center mt-4">
                <Document
                  file={resumeLink}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  <Page 
                    pageNumber={pageNumber}
                    scale={width > 786 ? 1.0 : 0.5}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                    className="shadow"
                    style={{ border: "1px solid #ddd" }}
                  />
                </Document>

                <div className="d-flex justify-content-center align-items-center mt-3">
                  <Button 
                    variant="outline-primary" 
                    onClick={goToPrevPage}
                    disabled={pageNumber <= 1}
                    className="mx-2"
                  >
                    <AiOutlineLeft />
                  </Button>
                  
                  <span className="mx-3">
                    Page {pageNumber} of {numPages}
                  </span>
                  
                  <Button 
                    variant="outline-primary" 
                    onClick={goToNextPage}
                    disabled={pageNumber >= numPages}
                    className="mx-2"
                  >
                    <AiOutlineRight />
                  </Button>
                </div>
              </div>
              
              <div className="d-flex justify-content-center mt-3 mb-5">
                <Button 
                  variant="primary" 
                  href={pdf} 
                  download="Harish_K_G_Resume.pdf"
                  className="d-flex align-items-center"
                >
                  <AiOutlineDownload className="me-2" />
                  Download Full Resume
                </Button>
              </div>
            </div>
          </Container>
        </Container>
      </section>
    </div>
  );
}

export default Resume;